<button mat-raised-button [color]="color" [disabled]="disabled" class="generic-button" [class.border-accent]="border" [class.generic-button-primary-loading]="color === 'primary' && isLoading" (click)="handleClick()">
    <div style="display: flex; align-items: center; justify-content: center;">
        <ng-container *ngIf="icon || isLoading">
            <mat-spinner *ngIf="isLoading" [color]="color === 'primary' ? 'accent' : 'primary'" diameter="20"></mat-spinner>
            <mat-icon *ngIf="!isLoading && icon">{{icon}}</mat-icon>
        </ng-container>
        <p class="generic-button-text" style="margin-left: 10px;">{{text}}</p>
    </div>
</button>